import { useSelector } from "react-redux";
import { selectCurrentLogbook } from "../../store/features/logbooks.slice";
import LogbookFolders from "../common/logbook-folders";

export default function CompanyLogbookFolders() {
  const logbook = useSelector(selectCurrentLogbook);

  return (
    <LogbookFolders
      isCompanyUser
      logbookId={logbook.id}
      folders={logbook.folders}
      documents={logbook.documents}
      canEdit={!logbook.transfer?.acceptedOn}
      ownerId={logbook.ownerId}
    />
  );
}
